/* JDHT product page template behaviour. Content is server rendered, this only enhances it. */
(function () {
  // Accordions: collapsed on mobile, expanded on desktop. Content is in the HTML either way.
  var mq = window.matchMedia('(min-width: 750px)');
  function setAccordions() {
    document.querySelectorAll('details[data-jdht-auto]').forEach(function (d) { d.open = mq.matches; });
  }
  setAccordions();
  if (mq.addEventListener) mq.addEventListener('change', setAccordions);

  // Video facade: load the player only when tapped.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jdht-video]');
    if (!b) return;
    var frame = b.parentNode, src = b.getAttribute('data-jdht-video');
    var f = document.createElement('iframe');
    f.src = src; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
    f.title = b.getAttribute('data-title') || 'Video';
    frame.appendChild(f); b.remove();
  });

  // Offer line: update the post-discount figure when the variant changes.
  function initOffer(el) {
    var prices = JSON.parse(el.getAttribute('data-prices') || '{}');
    var pct = Number(el.getAttribute('data-percent')) || 0, min = Number(el.getAttribute('data-min')) || 0;
    var cur = el.getAttribute('data-currency') || 'GBP', out = el.querySelector('[data-after]');
    if (!out) return;
    var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur });
    function show(id) {
      var p = prices[id];
      if (p == null || p < min * 100) { out.hidden = true; return; }
      out.textContent = fmt.format(Math.round(p * (100 - pct) / 100) / 100);
      out.hidden = false;
    }
    function listen() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant; if (v) show(String(v.id));
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen); else listen();
  }
  document.querySelectorAll('[data-jdht-offer]').forEach(initOffer);

  // Sticky add to cart: mirrors the buy box price, variant and button state so they can never differ.
  var bar = document.getElementById('jdht-sticky');
  if (bar) {
    var btn = bar.querySelector('.jdht-sticky__btn'), priceEl = bar.querySelector('.jdht-sticky__price'), varEl = bar.querySelector('.jdht-sticky__variant');
    var submit = document.querySelector('.product-form__submit');
    var priceBox = document.querySelector('.product__info-container .price');
    var priceWrap = priceBox ? priceBox.parentNode : null;
    function sync() {
      var p = document.querySelector('.product__info-container .price');
      if (p) {
        var sale = p.querySelector('.price-item--sale'), reg = p.querySelector('.price-item--regular');
        var node = p.classList.contains('price--on-sale') && sale ? sale : reg;
        if (node) priceEl.textContent = node.textContent.trim();
      }
      var picked = [];
      document.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(function (i) { picked.push(i.value); });
      document.querySelectorAll('.product-form__input select').forEach(function (s) { picked.push(s.value); });
      picked = picked.filter(function (v, i) { return v && picked.indexOf(v) === i; });
      varEl.textContent = picked.join(' / '); varEl.hidden = !picked.length;
      if (submit) { btn.disabled = submit.disabled || submit.hasAttribute('aria-disabled') && submit.getAttribute('aria-disabled') === 'true'; var t = submit.textContent.trim().replace(/\s+/g, ' '); if (t) btn.textContent = t; }
    }
    if (submit) {
      sync();
      if (priceWrap) new MutationObserver(sync).observe(priceWrap, { childList: true, subtree: true, characterData: true });
      new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
      var form = document.querySelector('product-info') || document.body;
      form.addEventListener('change', function () { setTimeout(sync, 50); });
      var ticking = false;
      function toggleBar() {
        ticking = false;
        var show = submit.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true'); btn.tabIndex = show ? 0 : -1;
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(toggleBar); } }, { passive: true });
      window.addEventListener('resize', toggleBar);
      toggleBar();
      var bg = window.getComputedStyle(submit).backgroundColor; if (bg && bg !== 'rgba(0, 0, 0, 0)') btn.style.backgroundColor = bg;
      btn.addEventListener('click', function () { submit.click(); });
    }
  }
})();
